export default "__VITE_ASSET__31d0c8d4__"